import styled from 'styled-components';

export const Root = styled.div`
  height: 100%;
  width: 100%;
  position: relative;

  video {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
    z-index: 1;
  }
`;

export const NameContainer = styled.div<{ avatarImage?: string }>`
  height: ${(props) => (props.avatarImage ? 'auto' : '100%')};
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;

  p {
    font-size: 15px;
    color: #fff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const Video = styled.video`
  height: 100%;
  width: 100%;
`;
